import { states } from '@/constants/lifecycle';

const customDatasetActions = ({ settings, customActions }) => {
  const { readStatus, items } = customActions || { items: [], readStatus: states.NONE };
  const actions = readStatus === states.SUCCESS ? items.filter((a) => settings.dataset_actions.includes(a.label)) : [];

  return {
    actions,
    actionsReadStatus: readStatus,
  };
};

export default customDatasetActions;
